import { AdditionalCriteria } from './AdditionalCriteria';
import { CommonCriteria } from './CommonCriteria';
import { FilterCriteria } from './FilterCriteria';

export const AdditionalCriteriaWidget = AdditionalCriteria;
export const CommonCriteriaWidget = CommonCriteria;
export const FilterCriteriaWidget = FilterCriteria;

/**
 * Widgets
 *
 * @type {{FILTER_CRITERIA: ((function(*): Element)|*), ADDITIONAL_CRITERIA: ((function(*): Element)|*),
 *     COMMON_CRITERIA: ((function(*): Element)|*)}}
 */
export const widgets = {
  ADDITIONAL_CRITERIA: AdditionalCriteriaWidget,
  COMMON_CRITERIA: CommonCriteriaWidget,
  FILTER_CRITERIA: FilterCriteriaWidget,
};
